<section class="evrn-exports section">
  <div class="evrn-exports__inner">
    <div class="evrn-exports__cards">
      <div class="container">
        <h2 class="evrn-exports__title title-dark">EVRN Exports</h2>
      </div>

      <div class="evrn-exports__cards-wrapper container">
        @for (card of numberedCards; track card.number) {
          <div class="evrn-exports__card" [class.evrn-exports__card--upcoming]="card.upcoming">
            @if (card.upcoming) {
              <span class="evrn-exports__badge type-caption-c2">Upcoming</span>
            }

            <div class="evrn-exports__card-header">
              <span class="evrn-exports__card-number type-title-h8">{{ card.number }}</span>
              <p class="evrn-exports__card-title type-title-h8">{{ card.title }}</p>
            </div>

            <p class="evrn-exports__card-description type-body-b3">{{ card.description }}</p>
          </div>
        }
      </div>
    </div>

    <div class="container">
      <app-hover-expandable-cards [cards]="expandableCards" />
    </div>
  </div>
</section>
